

















































































































































































































































































































































import {Component, Mixins} from "vue-property-decorator";
import ObjectEditLayout from "@service/layouts/ObjectEditLayout.vue";
import ControlWrapperBorderless from "@share/common/ControlWrapperBorderless.vue";
import BorderlessTexarea from "@share/common/form/form-controls/text/BorderlessTextarea.vue";
import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import BackButton from "@service/components/common/back-button/BackButton.vue";
import TextSelect from "@share/common/form/form-controls/select/variations/text-select/TextSelect.vue";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import E404 from "@service/views/errors/e404.vue";
import {validationMixin} from "vuelidate";
import {SelectObjectSourceService} from "@share/common/services/selectControl/SelectObjectSourceService"
import {DropDownItem} from "@share/common/drop-down/types";
import {RouteNamesEnum} from "@service/router/RouteNamesEnum";
import {Debounce} from "vue-debounce-decorator";
import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue";
import {Problem} from "@api/models/tickets/Problem";
import {Idea} from "@api/models/tickets/Idea";
import DatePickerInput from '@share/common/form/form-controls/date/date-picker/DatePickerInput.vue';
import DragNDrop from "@share/common/form/form-controls/file/DragNDrop.vue"
import {noticeActions} from "@service/store/notice/actions";
import {Notice} from "@service/components/toast/type/Notice";
import {NoticeLevel} from "@service/components/toast/type/Enums";
import i18n from "@service/locale/i18";
import CommentsView from "@share/comments/components/Comments.vue";
import ObjectLayout from "@service/layouts/ObjectViewLayout.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import BorderlessText from "@share/common/form/form-controls/text/BorderlessText.vue";
import BorderlessCurrnecy from "@share/common/form/form-controls/text/BorderlessCurrency.vue";
import {TicketType} from "@share/ticketSystem/enums/TicketTypes";
import TicketFormBase from "@share/ticketSystem/components/TicketFormBase";
import { Element } from "@api/models/Element";
import getValidationObject from "./validation";

@Component({
    components: {
        AdminPanel,
        BackButton,
        BorderlessTexarea,
        ControlWrapperBorderless,
        E404,
        FormGroup,
        ObjectEditLayout,
        BorderlessText,
        BorderlessCurrnecy,
        SingleSelect,
        TextSelect,
        ToggleButton,
        DatePickerInput,
        DragNDrop,
        CommentsView,
        ObjectLayout,
        BounceSpinner
    },
    validations() {
        return getValidationObject((this as TicketCreate).isAdmin, (this as TicketCreate).ticketType,
            (this as TicketCreate).ticket?.hasBigEffect);
    }
})

export default class TicketCreate extends Mixins(validationMixin, TicketFormBase) {

    get ownerId(): DropDownItem {
        if (this.ticket) {
            let userId = '';
            if (this.ticket.ownerId) {
                userId = this.ticket.ownerId.toString();
            }
            return this.selectedListSources.owner.find((item) => item.id === userId) || {
                title: "",
                id: userId
            }
        }
        return {
            title: "",
            id: ""
        }
    }

    set ownerId(value: DropDownItem) {
        this.selectedListSources.owner = [value];
        if (this.ticket && value && Object.prototype.hasOwnProperty.call(value, 'id') && value.id !== undefined) {
            this.ticket.ownerId = value.id ? parseInt(value.id) : null;
            if (this.vTicket && this.vTicket.ownerId) {
                this.vTicket.ownerId.$model = this.ticket.ownerId;
            }
        }
    }

    async mounted() {
        this.selectSourceService = new SelectObjectSourceService(this.objectRepository);

        try {
            this.ticket = this.getEmptyTicket();

            //TODO: merge with edit form
            const [categories, statuses] = await Promise.all([
                this.ticketService.getCategories(this.ticketType),
                this.ticketService.getStatuses(this.ticketType)
            ]);

            if (categories?.length) {
                this.searchedSources.categories = categories
                    .map((category: Element) => ({id: category.id, title: category.title}));
            }

            if (statuses?.length) {
                this.searchedSources.statuses = statuses
                    .map((status: Element) => ({id: status.id, title: status.title}));
            }
        }
        catch(e) {
            this.$store.dispatch('reportException', e, {root: true});
        }
        finally {
            this.isLoading = false;
        }
    }

    @Debounce(500)
    async save() {
        this.$v.$touch();

        if (this.vTicket?.$invalid) {
            return
        }

        try {
            let ownerId: number | null | undefined = this.ticket?.ownerId;
            if (this.ticket) {
                delete this.ticket.ownerId
            }
            let createdTicket = await this.ticketService.createTicket(this.ticketType, this.ticket, ownerId || null);

            if (createdTicket?.data?.id) {
                const notice: Notice = {
                    text: i18n.t("tickets.ticketSuccessfullyCreated").toString(),
                    level: NoticeLevel.success
                }

                this.$store.dispatch(noticeActions.submitNotice, notice)

                let routeName;
                if (this.isAdmin) {
                    routeName = this.ticketType === TicketType.idea ?
                            RouteNamesEnum.ticketSystemIdeaEdit :
                            RouteNamesEnum.ticketSystemProblemEdit;
                } else {
                    routeName = this.ticketType === TicketType.idea ?
                            RouteNamesEnum.ticketSystemIdeaView :
                            RouteNamesEnum.ticketSystemProblemView;
                }
                this.$router.push({
                    name: routeName,
                    params: {
                        backend: this.$route.params.backend,
                        id: createdTicket.data.id
                    }
                });
            }

        }  catch (e) {
            this.$store.dispatch('reportException', e, {root: true});

            const notice: Notice = {
                text: this.$t("tickets.ticketCreateError").toString(),
                level: NoticeLevel.danger
            }

            this.$store.dispatch(noticeActions.submitNotice, notice);
        }
    }

    getEmptyTicket(): Idea | Problem {
        // TODO: move this logic to fabric
        let defaultValues = {
            ownerId: null,
            responsibleUserId: null,
            status: null,
            category: null,
            title: '',
            description: ''
        };

        if (this.ticketType === TicketType.idea) {
            Object.assign(defaultValues, { solution: '', hasBigEffect: false, effectFormation: null });
            return new Idea(defaultValues);
        }

        Object.assign(defaultValues, { riskLevel: null, riskLocation: '' });
        return new Problem(defaultValues);
    }
}
